import Swal from 'sweetalert2/dist/sweetalert2.esm.js';

$(document).on('ready turbolinks:load', () => {
  // Tracks clicks on links inside elements with data-track-changes.
  // If the selector pointed to by the value of data-track-changes has data-changed,
  // it will present a warning before navigating
  $('[data-track-changes] a').off('click').click((e) => {
    const $activeElem = $('.active[data-track-changes]');
    if (!$activeElem.length) { return; }
    if (!$($activeElem.data('track-changes')).data('changed')) { return; }

    e.preventDefault();
    const href = $(e.currentTarget).attr('href');
    Swal.fire({
      title: I18n.t('extras.confirm_modal.unsaved_changes.title'),
      text: I18n.t('extras.confirm_modal.unsaved_changes.message'),
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: I18n.t('extras.confirm_modal.unsaved_changes.cancel_button_text'),
      confirmButtonText: I18n.t('extras.confirm_modal.unsaved_changes.yes_button_text'),
    }).then((result) => {
      if (result.isDismissed) {
        Turbolinks.visit(href);
      }
    });
  });
});
